/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useFormContext } from '@jalik/react-form'
import LeaseInput, { LeaseInputProps } from '../inputs/LeaseInput'
import { FormTextFieldProps } from '../../../../client/js/components/form/fields/FormField'
import { parseNumber } from '@jalik/form-parser'

function LeaseField (props: FormTextFieldProps & Partial<LeaseInputProps>) {
  const { name = 'leaseId', ...others } = props

  const { errors, getFieldProps, handleSetValue } = useFormContext()
  const fieldProps = getFieldProps(name, others)

  return (
    <LeaseInput
      error={errors[name]?.message}
      {...fieldProps}
      name={name}
      onChange={handleSetValue(name, { parse: parseNumber })}
    />
  )
}

export default LeaseField
